import React from 'react';
import PropTypes from 'prop-types';
import HorizontalBarChart from './HorizontalBarChart';

const MotivosChart = ({ data, period }) => {
  return (
    <HorizontalBarChart
      data={{
        ...data,
        datasetLabel: 'Número de Atenciones'
      }}
      period={period}
      title="Atenciones por Motivo"
      topLabel="Top"
      allLabel="Todos los motivos"
      tooltipSuffix=" atenciones"
      defaultTopCount={4}
      noDataIcon="bi-graph-up"
      noDataMessage="No hay datos disponibles para el período seleccionado"
      useConsistentColors={true}
      minHeight={300}
      barHeight={80}
    />
  );
};

MotivosChart.propTypes = {
  data: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    data: PropTypes.arrayOf(PropTypes.number).isRequired,
  }),
  period: PropTypes.string.isRequired,
};

export default MotivosChart;
